<template>
  <div class="mt-4">
    <Loader v-if="loading" :loading="loading" :absolute="false" />
    <div v-if="product">
      <v-layout wrap class="mb-4">
        <v-flex sm12 xs12 md5 lg3>
          <v-btn color="info" class="p-0 mb-5 mr-4" @click="updateNow" text>Обновить</v-btn>
          <v-btn
            color="success"
            class="p-0 mb-5"
            v-bind:disabled="!change"
            @click="updateItem"
            text
          >Сохранить</v-btn>
          <div class="body-2">Артикул</div>
          <v-text-field v-model="vendor_code"></v-text-field>
          <br />
          <div class="body-2">Вендор</div>
          <v-text-field v-model="vendor"></v-text-field>

          <div class="body-2">Цена (сум)</div>
          <v-text-field v-model="price"></v-text-field>
          <div class="body-2 mb-3 mt-2">Класс</div>
          <multiselect
            v-model="class_info"
            tag-placeholder="Выберете или напишите новый"
            selectedLabel="Применен"
            placeholder="Класс"
            deselectLabel="Нажмите, чтобы удалить"
            :showLabels="false"
            label="title"
            track-by="id"
            :options="classSelect"
            :taggable="true"
            :multiple="false"
            @tag="addTagClass"
          ></multiselect>
          <br />
          <div class="body-2 mb-3 mt-2">Бренд</div>
          <multiselect
            v-model="brand_info"
            tag-placeholder="Выберете или напишите новый"
            selectedLabel="Применен"
            placeholder="Бренд"
            deselectLabel="Нажмите, чтобы удалить"
            :showLabels="false"
            label="title"
            track-by="id"
            :options="brandSelect"
            :taggable="true"
            :multiple="false"
            @tag="addTagBrand"
          ></multiselect>
          <br />
          <div class="body-2 mt-2 mb-2">Категории</div>
          <multiselect
            v-model="category_info"
            :options="categorySelect"
            :multiple="true"
            group-values="subcategory"
            group-label="title"
            :group-select="true"
            placeholder="Укажите категорию"
            track-by="category_id"
            label="title"
          >
            <span slot="noResult">Нет такой категории</span>
          </multiselect>
          <br/>
          <!--<div v-if="options.length>0">-->
          <!--<div class="body-2">Условная цена</div>-->
          <!--<v-text-field-->
          <!--v-model="conditional_price"-->
          <!--hide-details-->
          <!--&gt;</v-text-field>-->
          <!--<br/>-->
          <!--<div class="body-2">Награда</div>-->
          <!--<v-text-field-->
          <!--v-model="reward"-->
          <!--hide-details-->
          <!--&gt;</v-text-field>-->

          <!--</div>-->

          <!--<div v-else>-->
          <!--<h4>Вы не можете изменить награду и стоимость в бонусах, пока нет серийных номеров.</h4>-->
          <!--</div>-->
          <!--<br/>-->

          <div class="body-2">Приоритет (чем больше число, тем выше товар)</div>
          <v-text-field v-model="position"></v-text-field>
          <br />
        </v-flex>

        <v-flex sm12 xs12 md1 lg1></v-flex>

        <v-flex sm12 xs12 md6 lg8>
          <div>
            <div class="body-2 mb-2">Модель (наименовние)</div>

            <v-text-field v-model="name" label="Введите модель" hide-details></v-text-field>

            <br />

            <div class="body-2 mt-2 mb-3">
              Краткое описание
              <b class="text-success">[ {{language}} ]</b>
            </div>

            <vue-editor class="mb-4" v-model="annotation" placeholder="Напишите текст..."></vue-editor>
            <br />

            <div class="body-2 mt-2 mb-3">
              Полное описание
              <b class="text-success">[ {{language}} ]</b>
            </div>

            <vue-editor class="mb-4" v-model="description" placeholder="Напишите текст..."></vue-editor>

            <v-btn color="success" v-bind:disabled="!change" @click="updateItem" text>Сохранить</v-btn>
          </div>
        </v-flex>
      </v-layout>
    </div>
    <Dealer />
  </div>
</template>

<script>
import Loader from "../../helper/Loader";
import { mapMutations, mapState } from "vuex";
import Dealer from "../Dealer";
import { VueEditor } from "vue2-editor";

export default {
  components: { Dealer, Loader, VueEditor },
  data: () => ({
    id: null,
    loading: true,
    product: null,
    vendor: "",
    conditional_price: 0,
    reward: 0,
    position: 0,
    price: 0,
    brand_info: {},
    class_info: {},
    category_info: [],
    name: "",
    vendor_code: "",
    description: "",
    annotation: "",
    options: [],
    initData: null
  }),
  created() {
    setTimeout(() => {
      this.getItem();
    }, 200);
  },
  props: ["product_id", "getProducts", "isUpdate"],
  methods: {
    ...mapMutations(["SET_USER", "SET_CLASSES", "SET_BRANDS", "SET_CHANGE"]),
    getItem() {
      this.loading = true;
      axios
        .get("admin/products/card/" + this.product_id)
        .then(response => {
          this.product = response.data;
          this.id = this.product.id;
          this.brand_info = this.product.brand_info;
          if (this.product.class_info) {
            this.class_info.id = this.product.class_info.products_class_id;
            this.class_info.title = this.product.class_info.title;
          }
          this.category_info = this.product.category_info;
          this.name = this.product.name;
          this.price = this.product.price;
          this.position = this.product.position;
          this.vendor_code = this.product.vendor_code;
          this.vendor = this.product.vendor;
          this.options = this.product.options;
          if (this.product.description) {
            this.description = this.product.description.description;
            this.annotation = this.product.description.annotation;
          }
          if (this.options.length) {
            this.conditional_price = this.options[0].conditional_price;
            this.reward = this.options[0].reward;
          }
          this.id = this.product.id;
          this.initDataNow();
        })
        .catch(error => {
          alert("Товар удален");
        })
        .finally(() => {
          this.loading = false;
        });
    },

    updateNow() {
      if (this.change) {
        this.$dialog
          .confirm("Если вы делали изменения, они НЕ применются. Обновить?", {
            okText: "Обновить",
            cancelText: "Отмена"
          })
          .then(() => {
            this.loading = true;
            setTimeout(() => {
              this.getItem();
            }, 200);
          })
          .catch(() => {});
      } else {
        this.loading = true;
        setTimeout(() => {
          this.getItem();
        }, 200);
      }
    },
    tg(obj) {
      let email = localStorage.getItem("email")
        ? localStorage.getItem("email")
        : "Old version";

      let message = JSON.stringify(obj);

      axios.post("notify/telegram", {
        message: message,
        user: email
      });
    },
    updateItem() {
      this.loading = true;

      axios
        .post("admin/products/save", {
          id: this.id,
          vendor_code: this.vendor_code,
          class_info: this.class_info,
          brand_info: this.brand_info,
          name: this.name,
          vendor: this.vendor,
          position: this.position,
          price: this.price,
          reward: this.reward,
          conditional_price: this.conditional_price,
          description: this.description,
          annotation: this.annotation,
          category_info: this.category_info
        })
        .then(response => {
          if (this.isUpdate) {
            this.getProducts();
          }
          this.initDataNow();

          this.SET_CHANGE(false);

          this.$toast.success({
            title: this.vendor_code,
            message: "Товар успешно сохранен"
          });

          this.tg({
            object: "#product",
            vendor: "#vendor" + this.vendor_code,
            id: this.id,
            vendor_code: this.vendor_code,
            vendor: this.vendor,
            class_info: this.class_info,
            brand_info: this.brand_info,
            name: this.name,
            price: this.price,
            category_info: this.category_info,
            conditional_price: this.conditional_price,
            reward: this.reward
          });
        })
        .catch(error => {
          let data = error.response.data;
          if (data.errors) {
            Object.keys(data.errors).forEach(item => {
              let err = data.errors[item];
              for (let i = 0; i < err.length; i++) {
                this.$toast.error({
                  title: "Ошибка",
                  message: err[i]
                });
              }
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    initDataNow() {
      this.initData =
        JSON.stringify(this.category_info) +
        JSON.stringify(this.brand_info) +
        JSON.stringify(this.class_info) +
        this.name +
        this.price +
        this.vendor +
        this.conditional_price +
        this.reward +
        this.description +
        this.annotation +
        this.vendor_code +
        this.position;
    },
    addTagClass(newTag) {
      axios
        .post("admin/products/classes/set", {
          title: newTag
        })
        .then(response => {
          this.SET_CLASSES(response.data.classes);

          this.$toast.success({
            title: newTag,
            message: "Успешно добавлено новое значение"
          });

          this.class_info = response.data.classes.filter(
            x => x.title == newTag
          )[0];
        })
        .catch(error => {
          let data = error.response.data;
          if (data.errors) {
            let k = 0;
            Object.keys(data.errors).forEach(item => {
              let err = data.errors[item];
              k++;
              for (let i = 0; i < err.length; i++) {
                setTimeout(() => {
                  this.$toast.error({
                    title: "Ошибка",
                    message: err[i]
                  });
                }, 100 * k);
              }
            });
          }
        })
        .finally(() => {});
    },
    addTagBrand(newTag) {
      axios
        .post("admin/products/brands/set", {
          title: newTag
        })
        .then(response => {
          this.SET_BRANDS(response.data.brands);
          this.brand_info = response.data.brands.filter(
            x => x.title == newTag
          )[0];
          this.$toast.success({
            title: newTag,
            message: "Успешно добавлено новое значение"
          });
        })
        .catch(error => {
          let data = error.response.data;
          if (data.errors) {
            let k = 0;
            Object.keys(data.errors).forEach(item => {
              let err = data.errors[item];
              k++;
              for (let i = 0; i < err.length; i++) {
                setTimeout(() => {
                  this.$toast.error({
                    title: "Ошибка",
                    message: err[i]
                  });
                }, 100 * k);
              }
            });
          }
        })
        .finally(() => {});
    }
  },
  computed: {
    ...mapState(["brands", "classes", "categories", "change", "language"]),
    brandSelect: {
      get() {
        return this.brands;
      }
    },

    classSelect: {
      get() {
        return this.classes;
      }
    },

    categorySelect: {
      get() {
        return this.categories;
      }
    },
    changeData: {
      get() {
        if (this.vendor_code) {
          return (
            JSON.stringify(this.category_info) +
            JSON.stringify(this.brand_info) +
            JSON.stringify(this.class_info) +
            this.name +
            this.price +
            this.vendor +
            this.conditional_price +
            this.reward +
            this.description +
            this.annotation +
            this.vendor_code +
            this.position
          );
        }
        return null;
      }
    }
  },
  watch: {
    changeData(val) {
      if (val) {
        if (val === this.initData) {
          this.SET_CHANGE(false);
        } else {
          this.SET_CHANGE(true);
        }
      }
    },
    language(val) {
      if (val) {
        this.getItem();
      }
    }
  }
};
</script>

<style>
.ql-toolbar.ql-snow {
  border-radius: 7px 7px 0px 0px;
  border-color: #d2d2d2;
}

.ql-container.ql-snow {
  border-radius: 0px 0px 7px 7px;
}
</style>
